<template>
  <div class="top-list list-num3">
    <div class="title3">热门礼包</div>
    <div v-for="(item, index) in list" :key="item.id" class="game-item3">
      <img
        :src="item.icon"
        @click="
          clickStat(index)
          $util.goGiftDetail(item)
        "
      />
      <div class="content">
        <div
          class="title3-1 ellipsis-1"
          @click="
            clickStat(index)
            $util.goGiftDetail(item)
          "
        >
          {{ item.title }}
        </div>
        <div class="tip">
          还剩 <em>{{ Math.max(0, item.quantity - item.granted) }}</em> 个
          <VipIcon :level="item.vip_level" />
        </div>
        <button
          @click="
            clickStat(index)
            $emit('get-gift', item)
          "
        >
          马上领取
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    statParams: {
      type: Object,
      required: false
    }
  },
  methods: {
    clickStat(index) {
      if (!this.statParams) {
        return
      }
      this.$util.clickStat(
        `${this.statParams.eid}${index + 1}`,
        `${this.statParams.eid_desc}${index + 1}`
      )
    }
  }
}
</script>
